var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 486,
    viewBox: "0 0 486 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Woman Server Rack Network Cloud Storage Transfer Download Upload 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M273.764 122.982C273.817 122.239 273.851 121.485 273.851 120.732V120.732C273.857 103.653 260.017 89.8035 242.938 89.7976C237.344 89.7956 231.855 91.3109 227.054 94.1818V94.1818C221.106 69.7868 196.508 54.8329 172.113 60.7813C152.37 65.5952 138.22 82.9251 137.451 103.231V103.231C121.106 103.47 107.98 116.788 107.979 133.135V133.135C107.979 149.655 121.372 163.048 137.893 163.048H268.024V163.048C279.316 163.048 288.47 153.894 288.47 142.602V142.602V142.606C288.47 133.526 282.482 125.534 273.768 122.983L273.764 122.982Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M137.893 163.048H268.024C279.316 163.048 288.47 153.894 288.47 142.602V142.578C288.452 141.066 287.217 139.853 285.705 139.861H136.79C122.006 139.861 121.034 161.945 135.779 162.975C136.479 163.024 137.183 163.048 137.893 163.048Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M273.764 122.982C273.817 122.239 273.851 121.485 273.851 120.732V120.732C273.857 103.653 260.017 89.8035 242.938 89.7976C237.344 89.7956 231.855 91.3109 227.054 94.1818V94.1818C221.106 69.7868 196.508 54.8329 172.113 60.7813C152.37 65.5952 138.22 82.9251 137.451 103.231V103.231C121.106 103.47 107.98 116.788 107.979 133.135V133.135C107.979 149.655 121.372 163.048 137.893 163.048H268.024V163.048C279.316 163.048 288.47 153.894 288.47 142.602V142.602V142.606C288.47 133.526 282.482 125.534 273.768 122.983L273.764 122.982Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M137.45 103.231C137.45 103.231 143.059 103.401 144.92 106.361",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M221.835 99.4649C222.253 98.8865 224.08 95.9511 227.055 94.182",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M273.764 122.982V122.982C273.691 124.075 273.487 125.156 273.156 126.2",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M139.059 93.2829C139.059 93.2829 137.688 99.6009 139.545 101.545C142.213 104.359 143.034 104.485 143.034 104.485C143.034 104.485 139.224 103.299 137.45 103.217C137.45 103.231 137.747 96.2669 139.059 93.2829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M224.095 86.022C224.221 86.3087 226.301 93.1127 223.497 97.2632V97.2632C224.32 96.3672 225.211 95.5353 226.16 94.7749C226.16 94.7749 227.307 94.459 227.055 93.6814C226.802 92.9038 225.961 90.4106 225.961 90.4106L224.095 86.022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M273.259 126.088V126.088C275.34 124.946 277.864 124.967 279.927 126.141C279.927 126.141 275.81 123.06 274.036 123.06C273.55 123.06 273.73 123.06 273.764 123.59",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M273.278 235.676V235.749V235.749C273.288 235.782 273.323 235.802 273.356 235.792C273.377 235.786 273.394 235.77 273.4 235.749V235.676V235.676C273.39 235.642 273.355 235.623 273.322 235.633C273.301 235.639 273.284 235.655 273.278 235.676V235.676Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M222.511 284.256H321.533V432.457H222.511V284.256Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M222.511 284.256H321.533V432.457H222.511V284.256Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M220.625 284.256H262.421V432.457H220.625V284.256Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M220.625 284.256H254.193V432.457H220.625V284.256Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M220.625 284.256H262.421V432.457H220.625V284.256Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M272.024 302.832H319.837V304.848H272.024V302.832Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M272.024 291.76H331.107V302.831H272.024V291.76Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M272.024 291.76H331.107V302.831H272.024V291.76Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M272.024 291.76H281.652V302.831H272.024V291.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M272.024 291.76H281.652V302.831H272.024V291.76Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M285.929 296.499H287.523V298.093H285.929V296.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M289.607 296.499H291.202V298.093H289.607V296.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M293.291 296.499H294.885V298.093H293.291V296.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M296.975 296.499H298.569V298.093H296.975V296.499Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M272.024 321.406H319.837V323.423H272.024V321.406Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M272.024 310.335H331.107V321.406H272.024V310.335Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M272.024 310.335H331.107V321.406H272.024V310.335Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M272.024 310.335H281.652V321.406H272.024V310.335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M272.024 310.335H281.652V321.406H272.024V310.335Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M285.929 315.074H287.523V316.668H285.929V315.074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M289.607 315.074H291.202V316.668H289.607V315.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M293.291 315.074H294.885V316.668H293.291V315.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M296.975 315.074H298.569V316.668H296.975V315.074Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M272.024 339.986H319.837V342.003H272.024V339.986Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M272.024 328.915H331.107V339.986H272.024V328.915Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M272.024 328.915H331.107V339.986H272.024V328.915Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M272.024 328.915H281.652V339.986H272.024V328.915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M272.024 328.915H281.652V339.986H272.024V328.915Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M285.929 333.654H287.523V335.248H285.929V333.654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M289.607 333.654H291.202V335.248H289.607V333.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M293.291 333.654H294.885V335.248H293.291V333.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M296.975 333.654H298.569V335.248H296.975V333.654Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M272.024 358.561H319.837V360.578H272.024V358.561Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M272.024 347.49H331.107V358.561H272.024V347.49Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M272.024 347.49H331.107V358.561H272.024V347.49Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M272.024 347.49H281.652V358.561H272.024V347.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M272.024 347.49H281.652V358.561H272.024V347.49Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M285.929 352.228H287.523V353.823H285.929V352.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M289.607 352.228H291.202V353.823H289.607V352.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M293.291 352.228H294.885V353.823H293.291V352.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M296.975 352.228H298.569V353.823H296.975V352.228Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M272.024 377.141H319.837V379.158H272.024V377.141Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M272.024 366.07H331.107V377.141H272.024V366.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M272.024 366.07H331.107V377.141H272.024V366.07Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M272.024 366.07H281.652V377.141H272.024V366.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M272.024 366.07H281.652V377.141H272.024V366.07Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M285.929 370.808H287.523V372.402H285.929V370.808Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M289.607 370.808H291.202V372.402H289.607V370.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M293.291 370.808H294.885V372.402H293.291V370.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M296.975 370.808H298.569V372.402H296.975V370.808Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M272.024 395.716H319.837V397.733H272.024V395.716Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M272.024 384.645H331.107V395.716H272.024V384.645Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M272.024 384.645H331.107V395.716H272.024V384.645Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M272.024 384.645H281.652V395.716H272.024V384.645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M272.024 384.645H281.652V395.716H272.024V384.645Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M285.929 389.383H287.523V390.977H285.929V389.383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M289.607 389.383H291.202V390.977H289.607V389.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M293.291 389.383H294.885V390.977H293.291V389.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M296.975 389.383H298.569V390.977H296.975V389.383Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M272.024 414.296H319.837V416.312H272.024V414.296Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M272.024 403.224H331.107V414.296H272.024V403.224Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M272.024 403.224H331.107V414.296H272.024V403.224Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M272.024 403.224H281.652V414.296H272.024V403.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M272.024 403.224H281.652V414.296H272.024V403.224Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M285.929 407.958H287.523V409.552H285.929V407.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M289.607 407.958H291.202V409.552H289.607V407.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M293.291 407.958H294.885V409.552H293.291V407.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M296.975 407.958H298.569V409.552H296.975V407.958Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M196.368 235.676V235.749V235.749C196.378 235.782 196.413 235.802 196.446 235.792C196.467 235.786 196.484 235.77 196.49 235.749V235.676V235.676C196.48 235.642 196.445 235.623 196.412 235.633C196.391 235.639 196.374 235.655 196.368 235.676V235.676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M145.601 244.628H244.623V432.453H145.601V244.628Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M145.601 244.628H244.623V432.453H145.601V244.628Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M143.72 244.628H185.516V432.453H143.72V244.628Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M151.681 334.451H175.825V432.453H151.681V334.451Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M143.72 244.628H185.516V432.453H143.72V244.628Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M195.114 265.677H242.927V267.694H195.114V265.677Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M195.114 254.606H254.197V265.677H195.114V254.606Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M195.114 254.606H254.197V265.677H195.114V254.606Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M195.114 254.606H204.742V265.677H195.114V254.606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M195.114 254.606H204.742V265.677H195.114V254.606Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M209.019 259.344H210.613V260.938H209.019V259.344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M212.703 259.344H214.297V260.938H212.703V259.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M216.387 259.344H217.981V260.938H216.387V259.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M220.065 259.344H221.66V260.938H220.065V259.344Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M195.114 284.256H242.927V286.273H195.114V284.256Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M195.114 273.186H254.197V284.257H195.114V273.186Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M195.114 273.186H254.197V284.257H195.114V273.186Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M195.114 273.186H204.742V284.257H195.114V273.186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M195.114 273.186H204.742V284.257H195.114V273.186Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M209.019 277.919H210.613V279.513H209.019V277.919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M212.703 277.919H214.297V279.513H212.703V277.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M216.387 277.919H217.981V279.513H216.387V277.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M220.065 277.919H221.66V279.513H220.065V277.919Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M195.114 302.832H242.927V304.848H195.114V302.832Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M195.114 291.76H254.197V302.831H195.114V291.76Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M195.114 291.76H254.197V302.831H195.114V291.76Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M195.114 291.76H204.742V302.831H195.114V291.76Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M195.114 291.76H204.742V302.831H195.114V291.76Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M209.019 296.499H210.613V298.093H209.019V296.499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M212.703 296.499H214.297V298.093H212.703V296.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M216.387 296.499H217.981V298.093H216.387V296.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M220.065 296.499H221.66V298.093H220.065V296.499Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M195.114 321.406H242.927V323.423H195.114V321.406Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M195.114 310.335H254.197V321.406H195.114V310.335Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M195.114 310.335H254.197V321.406H195.114V310.335Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M195.114 310.335H204.742V321.406H195.114V310.335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M195.114 310.335H204.742V321.406H195.114V310.335Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M209.019 315.074H210.613V316.668H209.019V315.074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M212.703 315.074H214.297V316.668H212.703V315.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M216.387 315.074H217.981V316.668H216.387V315.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M220.065 315.074H221.66V316.668H220.065V315.074Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M195.114 339.986H242.927V342.003H195.114V339.986Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M195.114 328.915H254.197V339.986H195.114V328.915Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M195.114 328.915H254.197V339.986H195.114V328.915Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M195.114 328.915H204.742V339.986H195.114V328.915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M195.114 328.915H204.742V339.986H195.114V328.915Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M209.019 333.654H210.613V335.248H209.019V333.654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M212.703 333.654H214.297V335.248H212.703V333.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M216.387 333.654H217.981V335.248H216.387V333.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M220.065 333.654H221.66V335.248H220.065V333.654Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M195.114 358.561H242.927V360.578H195.114V358.561Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M195.114 347.49H254.197V358.561H195.114V347.49Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M195.114 347.49H254.197V358.561H195.114V347.49Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M195.114 347.49H204.742V358.561H195.114V347.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M195.114 347.49H204.742V358.561H195.114V347.49Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M209.019 352.228H210.613V353.823H209.019V352.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M212.703 352.228H214.297V353.823H212.703V352.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M216.387 352.228H217.981V353.823H216.387V352.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M220.065 352.228H221.66V353.823H220.065V352.228Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M195.114 377.141H242.927V379.158H195.114V377.141Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M195.114 366.07H254.197V377.141H195.114V366.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M195.114 366.07H254.197V377.141H195.114V366.07Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M195.114 366.07H204.742V377.141H195.114V366.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M195.114 366.07H204.742V377.141H195.114V366.07Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M209.019 370.808H210.613V372.402H209.019V370.808Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M212.703 370.808H214.297V372.402H212.703V370.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M216.387 370.808H217.981V372.402H216.387V370.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M220.065 370.808H221.66V372.402H220.065V370.808Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M195.114 395.716H242.927V397.733H195.114V395.716Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M195.114 384.645H254.197V395.716H195.114V384.645Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M195.114 384.645H254.197V395.716H195.114V384.645Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M195.114 384.645H204.742V395.716H195.114V384.645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M195.114 384.645H204.742V395.716H195.114V384.645Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M209.019 389.383H210.613V390.977H209.019V389.383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M212.703 389.383H214.297V390.977H212.703V389.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M216.387 389.383H217.981V390.977H216.387V389.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M220.065 389.383H221.66V390.977H220.065V389.383Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M195.114 414.296H242.927V416.312H195.114V414.296Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M195.114 403.224H254.197V414.296H195.114V403.224Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M195.114 403.224H254.197V414.296H195.114V403.224Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M195.114 403.224H204.742V414.296H195.114V403.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M195.114 403.224H204.742V414.296H195.114V403.224Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M209.019 407.958H210.613V409.552H209.019V407.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M212.703 407.958H214.297V409.552H212.703V407.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M216.387 407.958H217.981V409.552H216.387V407.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M220.065 407.958H221.66V409.552H220.065V407.958Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M195.114 420.546H196.655V425.192H195.114V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M199.158 420.546H200.699V425.192H199.158V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M203.202 420.546H204.743V425.192H203.202V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M207.245 420.546H208.786V425.192H207.245V420.546Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M117.996 235.676V235.749V235.749C118.006 235.782 118.041 235.802 118.074 235.792C118.095 235.786 118.112 235.77 118.118 235.749V235.676V235.676C118.108 235.642 118.073 235.623 118.039 235.633C118.018 235.639 118.002 235.655 117.996 235.676V235.676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M67.2285 321.406H166.251V432.452H67.2285V321.406Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M67.2285 321.406H166.251V432.452H67.2285V321.406Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M65.3428 321.406H107.139V432.452H65.3428V321.406Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M103.605 321.406H107.143V432.452H82.79V342.227V342.222C82.79 330.726 92.1094 321.406 103.605 321.406C103.607 321.406 103.609 321.406 103.61 321.406H103.605Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M65.3428 321.406H107.139V432.452H65.3428V321.406Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M116.742 339.986H164.555V342.003H116.742V339.986Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M116.742 328.915H175.825V339.986H116.742V328.915Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M116.742 328.915H175.825V339.986H116.742V328.915Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M116.742 328.915H126.37V339.986H116.742V328.915Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M116.742 328.915H126.37V339.986H116.742V328.915Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M130.646 333.654H132.241V335.248H130.646V333.654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M134.33 333.654H135.924V335.248H134.33V333.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M138.01 333.654H139.604V335.248H138.01V333.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M141.693 333.654H143.287V335.248H141.693V333.654Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M116.742 358.561H164.555V360.578H116.742V358.561Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M116.742 347.49H175.825V358.561H116.742V347.49Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M116.742 347.49H175.825V358.561H116.742V347.49Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M116.742 347.49H126.37V358.561H116.742V347.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M116.742 347.49H126.37V358.561H116.742V347.49Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M130.646 352.228H132.241V353.823H130.646V352.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M134.33 352.228H135.924V353.823H134.33V352.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M138.01 352.228H139.604V353.823H138.01V352.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M141.693 352.228H143.287V353.823H141.693V352.228Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M116.742 377.141H164.555V379.158H116.742V377.141Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M116.742 366.07H175.825V377.141H116.742V366.07Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M116.742 366.07H175.825V377.141H116.742V366.07Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M116.742 366.07H126.37V377.141H116.742V366.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M116.742 366.07H126.37V377.141H116.742V366.07Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M130.646 370.808H132.241V372.402H130.646V370.808Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M134.33 370.808H135.924V372.402H134.33V370.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M138.01 370.808H139.604V372.402H138.01V370.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M141.693 370.808H143.287V372.402H141.693V370.808Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M116.742 395.716H164.555V397.733H116.742V395.716Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M116.742 384.645H175.825V395.716H116.742V384.645Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M116.742 384.645H175.825V395.716H116.742V384.645Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M116.742 384.645H126.37V395.716H116.742V384.645Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M116.742 384.645H126.37V395.716H116.742V384.645Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M130.646 389.383H132.241V390.977H130.646V389.383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M134.33 389.383H135.924V390.977H134.33V389.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M138.01 389.383H139.604V390.977H138.01V389.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M141.693 389.383H143.287V390.977H141.693V389.383Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M116.742 414.296H164.555V416.312H116.742V414.296Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M116.742 403.224H175.825V414.296H116.742V403.224Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M116.742 403.224H175.825V414.296H116.742V403.224Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M116.742 403.224H126.37V414.296H116.742V403.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M116.742 403.224H126.37V414.296H116.742V403.224Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M130.646 407.958H132.241V409.552H130.646V407.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M134.33 407.958H135.924V409.552H134.33V407.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M138.01 407.958H139.604V409.552H138.01V407.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M141.693 407.958H143.287V409.552H141.693V407.958Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M272.024 420.546H273.565V425.192H272.024V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M276.067 420.546H277.608V425.192H276.067V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M280.106 420.546H281.647V425.192H280.106V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M284.149 420.546H285.69V425.192H284.149V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M116.742 420.546H118.283V425.192H116.742V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M120.786 420.546H122.327V425.192H120.786V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M124.829 420.546H126.37V425.192H124.829V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M128.873 420.546H130.414V425.192H128.873V420.546Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M163.622 151.457C161.746 151.457 160.225 149.936 160.225 148.06C160.225 146.184 161.746 144.663 163.622 144.663H232.828C234.704 144.663 236.225 146.184 236.225 148.06C236.225 149.936 234.704 151.457 232.828 151.457H163.622Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M163.622 151.452V151.452C161.743 151.452 160.22 149.929 160.22 148.05V148.05C160.22 146.171 161.743 144.648 163.622 144.648H232.828V144.648C234.707 144.648 236.23 146.171 236.23 148.05C236.23 149.929 234.707 151.452 232.828 151.452",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M113.835 293.53C117.711 297.405 117.711 303.689 113.835 307.565C109.959 311.44 103.676 311.44 99.8003 307.565C95.9247 303.689 95.9247 297.405 99.8003 293.53C103.676 289.654 109.959 289.654 113.835 293.53Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M188.845 220.582L199.928 209.499L211.01 220.582L199.928 231.665L188.845 220.582Z",
    fill: "#FF382D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M291.862 250.45H281.588L276.451 259.344L281.588 268.238H291.862L296.994 259.344L291.862 250.45Z",
    fill: "#51D6E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M143.72 233.717L133.995 250.553H153.44L143.72 233.717Z",
    fill: "#4C5BFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M88.6611 209.111H93.3996V213.85H88.6611V209.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M88.6611 248.186H93.3996V252.924H88.6611V248.186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M104.451 248.186H109.19V252.924H104.451V248.186Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M167.84 176.496H172.578V181.234H167.84V176.496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M141.349 209.111H146.087V213.85H141.349V209.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M167.84 209.111H172.578V213.85H167.84V209.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M258.013 209.111H262.751V213.85H258.013V209.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M227.273 209.111H232.012V213.85H227.273V209.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M310.7 209.111H315.439V213.85H310.7V209.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M310.7 256.977H315.439V261.716H310.7V256.977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M197.56 176.496H202.298V181.234H197.56V176.496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M227.273 176.496H232.012V181.234H227.273V176.496Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M170.211 151.452V211.478H91.0322V250.553H106.818V300.547",
    stroke: "black",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M199.926 151.452V220.586",
    stroke: "black",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M229.645 151.452V178.863V211.478H260.379H313.066V259.344H286.725",
    stroke: "black",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M372.587 234.66V234.66C371.849 236.975 371.36 239.362 371.129 241.78C370.896 243.549 370.697 245.474 371.445 247.155C372.986 250.616 377.579 250.737 380.193 248.419C380.427 248.21 380.082 247.865 379.848 248.074V248.074C378.406 249.357 376.414 249.824 374.551 249.318C372.719 248.793 371.684 247.141 371.465 245.328C371.275 243.758 371.552 242.169 371.766 240.619V240.619C371.995 238.635 372.428 236.681 373.059 234.787C373.166 234.49 372.694 234.364 372.573 234.66H372.587Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M378.273 241.649V241.649C378.27 241.679 378.252 241.705 378.224 241.717L378.409 241.693H378.361L378.531 241.863V241.819L378.506 242.009V242.009C378.553 241.929 378.606 241.854 378.667 241.785C378.856 241.532 378.433 241.299 378.244 241.537C378.132 241.688 378.03 241.795 378.069 241.994V241.994C378.092 242.077 378.156 242.141 378.239 242.164C378.725 242.252 378.89 241.634 378.628 241.318C378.429 241.075 378.088 241.42 378.283 241.659L378.273 241.649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M373.389 240.818V240.818C373.389 240.848 373.37 240.876 373.341 240.886H373.525H373.477L373.647 241.056V241.012V241.197V241.197C373.694 241.12 373.748 241.047 373.807 240.978C373.997 240.725 373.574 240.492 373.385 240.73C373.273 240.881 373.171 240.988 373.214 241.187V241.187C373.236 241.269 373.299 241.333 373.38 241.357C373.866 241.445 374.031 240.828 373.768 240.512C373.506 240.196 373.229 240.614 373.423 240.852L373.389 240.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M383.251 243.369C384.572 242.99 386.361 241.493 385.681 239.919V239.919C385.405 239.304 384.744 238.959 384.082 239.083V239.083C383.363 239.221 382.775 239.736 382.541 240.429C382.424 240.716 382.891 240.842 383.027 240.555V240.555C383.222 239.986 383.739 239.588 384.339 239.545C385.277 239.545 385.452 240.516 385.161 241.207V241.207C384.772 242.052 384.021 242.676 383.119 242.903V242.903C382.985 242.938 382.905 243.075 382.94 243.209C382.974 243.343 383.111 243.424 383.246 243.389L383.251 243.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M384.621 240.468C383.926 239.865 383.377 241.44 383.289 241.872C383.289 241.95 383.391 241.984 383.406 241.906C383.474 241.566 383.96 240.055 384.533 240.55C384.592 240.604 384.679 240.516 384.621 240.468V240.468Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M384.105 241.095C383.955 240.827 383.663 240.988 383.522 241.168C383.474 241.231 383.58 241.294 383.624 241.231C383.746 241.046 383.872 241.017 383.998 241.153C384.037 241.226 384.139 241.153 384.105 241.095V241.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M382.968 243.136V243.136C382.926 247.149 383.127 251.161 383.571 255.15C383.6 255.456 384.086 255.461 384.057 255.15V255.15C383.613 251.161 383.412 247.149 383.455 243.136C383.455 243.002 383.346 242.893 383.212 242.893C383.077 242.893 382.969 243.002 382.969 243.136L382.968 243.136Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M374.526 249.964C374.594 251.641 374.755 253.322 374.696 254.999C374.696 255.31 375.182 255.31 375.182 254.999C375.241 253.322 375.08 251.641 375.012 249.964C375.012 249.648 374.526 249.648 374.526 249.964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M375.634 240.716V240.716C375.309 241.525 375.06 242.363 374.891 243.219C374.827 243.525 375.299 243.656 375.377 243.345V243.345C375.545 242.489 375.796 241.65 376.125 240.842C376.242 240.555 375.77 240.429 375.639 240.716L375.634 240.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M380.052 239.35V239.35C379.728 239.069 379.323 238.898 378.896 238.864C378.584 238.835 378.589 239.321 378.896 239.35V239.35C379.197 239.379 379.483 239.501 379.712 239.7C379.945 239.909 380.29 239.564 380.052 239.36V239.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M374.847 238.694V238.694C374.522 238.412 374.115 238.242 373.686 238.208C373.375 238.179 373.379 238.665 373.686 238.694V238.694C373.987 238.723 374.273 238.845 374.502 239.044C374.735 239.248 375.08 238.908 374.847 238.699V238.694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M380.052 248.409C380.052 248.409 377.981 252.428 375.012 253.93L374.983 252.283L374.871 249.658C374.871 249.658 374.638 249.605 375.357 249.76C377.078 250.12 379.469 249.055 380.052 248.409V248.409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M376.592 244.565V244.565C376.241 244.713 375.861 244.781 375.479 244.764V244.764C375.345 244.764 375.236 244.873 375.236 245.007C375.236 245.141 375.345 245.25 375.479 245.25V245.25C375.903 245.27 376.326 245.197 376.719 245.036C377.005 244.92 376.879 244.448 376.592 244.55V244.565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M387.624 238.446C387.269 232.464 382.239 231.336 382.239 231.336C382.239 231.336 372.898 227.448 370.789 237.353C370.755 237.498 377.554 238.568 380.023 235.341C379.537 236.22 378.818 237.445 378.507 237.955C378.507 237.955 380.738 238.179 381.374 236.828V236.828C381.156 238.14 381.854 239.434 383.07 239.972C383.07 239.972 383.731 239.044 384.562 239.331C385.394 239.617 385.637 239.71 385.534 240.395C385.432 241.08 384.601 242.47 384.149 242.713C383.697 242.956 383.095 242.815 383.177 244.132C383.26 245.449 383.075 247.564 383.075 247.564C383.075 247.564 387.979 244.424 387.624 238.446V238.446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M397.656 221.922C396.066 220.328 393.107 220.595 390.429 222.36V222.36C389.443 222.999 388.369 223.491 387.241 223.818V223.818C383.606 224.891 381.529 228.707 382.602 232.342C383.675 235.977 387.491 238.054 391.126 236.981C393.359 236.321 395.106 234.575 395.765 232.342V232.342C396.09 231.213 396.581 230.138 397.223 229.154C399.007 226.476 399.25 223.511 397.656 221.922V221.922Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M374.939 254.999V254.999C370.644 254.289 366.239 255.23 362.609 257.633C358.08 260.686 347.543 266.474 347.543 266.474C347.543 266.474 343.845 263.942 335.51 258.557C327.175 253.172 324.648 249.76 319.302 249.76C316.77 249.76 313.285 251.17 313.285 251.17",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M317.144 252.268V252.268C316.994 252.739 317.056 253.251 317.314 253.673C317.479 253.94 317.897 253.673 317.732 253.43V253.43C317.54 253.12 317.497 252.739 317.615 252.394C317.712 252.098 317.241 251.972 317.129 252.268H317.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M316.872 254.926V254.926C316.953 255.237 317.167 255.496 317.455 255.636C317.737 255.772 317.98 255.354 317.703 255.213V255.213C317.534 255.137 317.407 254.989 317.358 254.81V254.81C317.322 254.676 317.184 254.596 317.049 254.632C316.915 254.669 316.836 254.807 316.872 254.941V254.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M317.524 256.875V256.875C317.661 257.28 318.075 257.522 318.496 257.444C318.807 257.39 318.675 256.924 318.369 256.958V256.958C318.206 256.982 318.048 256.889 317.99 256.734C317.883 256.443 317.412 256.569 317.504 256.861L317.524 256.875Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M321.679 253.551C321.679 253.551 319.536 254.261 318.986 255.733C318.437 257.206 321.679 255.971 321.679 255.971C321.679 255.971 321.601 258.032 323.395 258.664C323.395 258.664 335.744 277.662 345.877 279.139C354.265 280.364 365.72 272.175 365.404 272.384",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M347.159 266.484V266.484C348.234 267.181 349.079 268.18 349.589 269.356C349.715 269.642 350.133 269.395 350.012 269.108V269.108C349.466 267.861 348.565 266.803 347.422 266.066C347.159 265.895 346.935 266.313 347.179 266.484H347.159Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M383.814 255.15C383.814 255.15 397.125 247.593 403.618 265.171C410.111 282.75 408.682 296.518 396.814 293.359C384.946 290.2 371.917 282.628 371.917 282.628V282.628C369.723 282.557 367.566 282.051 365.569 281.141C363.446 280.077 363.086 279.285 363.086 279.285",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M362.911 277.506V277.506C363.279 277.795 363.689 278.028 364.126 278.196C364.417 278.313 364.544 277.841 364.257 277.71V277.71C363.895 277.572 363.556 277.38 363.251 277.141C363.008 276.952 362.663 277.297 362.911 277.487V277.506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M363.79 275.611V275.611C364.224 275.982 364.683 276.321 365.166 276.626C365.433 276.792 365.652 276.369 365.409 276.204V276.204C364.961 275.923 364.535 275.61 364.135 275.266C363.897 275.061 363.552 275.406 363.79 275.611V275.611Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M365.773 274.031V274.031C366.699 274.758 367.804 275.222 368.971 275.372C369.55 275.445 370.313 275.538 370.531 274.886C370.628 274.59 370.162 274.464 370.045 274.76C369.865 275.29 368.135 274.76 367.824 274.639V274.639C367.165 274.404 366.548 274.064 365.997 273.633C365.749 273.443 365.511 273.866 365.754 274.051L365.773 274.031Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M372.188 273.657V273.657C372.777 274.48 373.181 275.42 373.374 276.412C373.374 276.412 377.831 277.278 385.33 278.536C394.345 280.043 398.452 281.778 398.452 281.778",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M366.667 274.347L368.358 263.412L379.181 265.473L379.551 268.879L394.354 271.727L393.081 280.13",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M372.003 254.766C372.003 254.766 370.895 261.458 376.912 261.828L377.753 263.942L378.812 261.619C378.812 261.619 388.046 262.294 388.79 253.614",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M365.564 281.122L364.825 284.893L384.474 288.888",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M370.298 286.006V287.328V287.328C370.299 288.879 370.103 290.423 369.715 291.925C367.217 301.645 357.463 340.846 356.782 364.514V364.514C356.751 365.408 357.391 366.185 358.274 366.327C364.422 367.299 388.056 370.604 409.032 366.395V366.395C409.921 366.211 410.53 365.389 410.446 364.485C409.562 354.648 404.508 301.937 396.809 293.339",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M359.927 366.58C359.927 366.58 357.88 395.41 357.288 427.568V427.568C357.28 427.894 357.135 428.201 356.889 428.414L354.493 430.455V430.455C354.018 430.866 353.966 431.584 354.377 432.059C354.591 432.308 354.903 432.451 355.232 432.452H365.516V432.452C366.04 432.456 366.497 432.097 366.619 431.587C367.839 426.509 374.001 400.085 375.425 378.127C375.994 369.423 376.071 368.189 376.071 368.189",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M393.48 368.281C393.48 368.281 399.798 411.005 403.026 427.087V427.087C403.094 427.437 402.991 427.798 402.749 428.059L400.464 430.552V430.552C400.04 431.012 400.069 431.728 400.529 432.152C400.739 432.346 401.014 432.453 401.3 432.453H411.186V432.453C411.788 432.451 412.284 431.98 412.318 431.378C412.561 426.635 413.411 406.976 411.939 388.392V388.392C411.301 380.958 410 373.597 408.051 366.395",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M359.324 259.952V259.952C362.095 263.617 364.142 267.777 365.355 272.209C365.355 272.281 365.496 272.252 365.472 272.175V272.174C364.256 267.732 362.204 263.562 359.426 259.888C359.382 259.83 359.275 259.888 359.324 259.952V259.952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M394.443 274.211C397.655 271.883 401.247 270.119 404.722 268.253C404.79 268.214 404.722 268.112 404.659 268.146C401.174 270.017 397.592 271.776 394.385 274.104C394.322 274.148 394.385 274.255 394.443 274.211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M369.079 294.55C371.222 294.842 371.961 297.991 371.509 299.75C370.921 302.088 368.812 302.729 366.649 302.899C366.571 302.899 366.571 303.031 366.649 303.021C369.006 302.831 371.256 302.049 371.684 299.425C371.981 297.656 371.198 294.715 369.089 294.433C369.011 294.433 368.977 294.54 369.055 294.55H369.079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M380.052 301.32C377.875 302.127 374.964 303.648 374.983 306.374C374.983 308.688 377.72 310.063 379.741 310.078V310.078C382.048 310.097 384.036 308.458 384.456 306.19V306.19C384.757 304.047 383.374 302.028 381.267 301.534V301.534C381.235 301.526 381.203 301.545 381.195 301.578C381.187 301.61 381.206 301.642 381.238 301.65V301.65C383.417 302.156 384.776 304.33 384.276 306.51V306.51C383.741 308.573 381.872 310.007 379.741 309.99C377.457 309.961 374.512 308.221 375.231 305.558C375.834 303.332 378.104 302.205 380.091 301.471C380.164 301.446 380.13 301.33 380.057 301.354L380.052 301.32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M377.506 289.627C376.121 290.404 374.862 292.105 375.795 293.69C376.675 295.182 378.711 295.697 380.335 295.381C382.05 295.046 383.411 293.845 383.314 292.018C383.221 290.278 382.04 288.703 380.179 288.888C380.101 288.888 380.101 289.014 380.179 289.01C382.065 288.82 383.192 290.468 383.202 292.203C383.212 293.938 381.861 294.963 380.286 295.264V295.264C378.859 295.568 377.375 295.158 376.306 294.166C374.794 292.616 375.98 290.618 377.555 289.734C377.623 289.695 377.555 289.588 377.491 289.627H377.506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M370.599 288.14V288.14C371.456 287.75 372.216 287.175 372.825 286.458C372.879 286.4 372.791 286.312 372.743 286.375V286.375C372.137 287.084 371.384 287.651 370.536 288.038C370.463 288.067 370.536 288.174 370.599 288.14V288.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M391.231 294.176V294.176C389.405 294.589 388.03 296.096 387.785 297.952C387.571 300.066 389.637 300.868 391.415 301.028C393.427 301.208 395.055 299.274 395.386 297.417C395.639 295.993 395.017 293.359 393.097 293.68C393.019 293.68 393.053 293.811 393.131 293.797L394.477 294.283V294.283C394.721 294.524 394.903 294.821 395.007 295.148V295.148C395.165 295.501 395.262 295.879 395.294 296.266V296.266C395.387 297.127 395.218 297.996 394.808 298.759V298.759C394.418 299.48 393.859 300.095 393.179 300.552C392.305 301.101 391.269 300.975 390.317 300.727C388.499 300.241 387.44 298.948 388.159 297.029V297.029C388.681 295.661 389.852 294.645 391.279 294.322C391.352 294.322 391.323 294.186 391.245 294.2L391.231 294.176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M397.802 308.906V308.906C396.546 308.529 395.185 308.781 394.147 309.582C393.175 310.258 392.018 311.215 391.586 312.367C390.769 314.534 393.083 316.95 394.963 317.664C397.233 318.529 399.775 317.149 400.698 315.006C401.393 313.387 401.578 309.976 399.551 309.174C399.478 309.145 399.444 309.261 399.517 309.29C401.729 310.146 401.179 314.029 400.266 315.57C399.177 317.402 396.669 318.369 394.696 317.402C392.723 316.435 390.619 313.951 392.038 311.759C393.189 309.976 395.629 308.28 397.782 308.989C397.86 308.989 397.889 308.897 397.816 308.872L397.802 308.906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M373.521 318.495C371.178 319.822 369.74 322.5 370.493 325.178V325.178C371.167 327.725 373.645 329.362 376.252 328.983C378.818 328.575 381.185 325.669 381.02 323.059C380.855 320.449 378.454 318.627 375.927 318.792C375.849 318.792 375.849 318.918 375.927 318.913C378.507 318.748 380.991 320.716 380.908 323.428C380.826 326.062 378.352 328.774 375.713 328.915V328.915C373.205 329.011 371.003 327.263 370.527 324.799C369.993 322.262 371.397 319.837 373.584 318.602C373.652 318.563 373.584 318.461 373.521 318.495V318.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M390.944 326.791C388.256 327.219 385.967 330.708 386.195 333.352C386.443 336.161 389.32 337.751 391.925 337.206C394.802 336.604 396.693 333.746 396.508 330.888V330.888C396.434 329.423 395.875 328.025 394.919 326.913C394.287 326.237 393.32 325.878 392.713 326.757C392.669 326.825 392.776 326.884 392.82 326.82C393.821 325.362 395.109 327.282 395.483 327.928V327.928C395.813 328.494 396.058 329.105 396.212 329.741V329.741C396.525 330.982 396.454 332.289 396.008 333.488V333.488C395.177 335.746 393.014 337.235 390.608 337.206C387.843 337.09 385.748 334.626 386.468 331.894C387.022 329.732 388.64 327.292 390.973 326.918C391.051 326.918 391.017 326.791 390.944 326.801V326.791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M404.542 335.69C401.597 336.662 398.657 340.38 399.872 343.646C401.087 346.912 405.364 348.02 408.032 345.915C408.095 345.867 408.008 345.779 407.949 345.828C405.033 348.102 400.061 346.377 399.809 342.47C399.614 339.5 401.85 336.711 404.576 335.811C404.649 335.787 404.62 335.666 404.542 335.69V335.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M406.121 335.982L406.607 336.297C406.675 336.341 406.734 336.239 406.67 336.195L406.184 335.88C406.121 335.836 406.058 335.938 406.126 335.982H406.121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M364.928 312.245V312.245C366.032 313.134 366.573 314.55 366.342 315.949C366.065 317.567 364.728 318.592 363.484 319.506C363.421 319.555 363.484 319.657 363.547 319.613C364.816 318.675 366.196 317.621 366.463 315.963V315.963C366.693 314.525 366.137 313.075 365.005 312.158C364.947 312.109 364.86 312.192 364.918 312.245H364.928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M365.259 339.228C363.281 341.012 362.863 344.224 364.603 346.333V346.333C366.385 348.437 369.468 348.856 371.747 347.305C373.929 345.735 374.979 342.275 373.205 340.015V340.015C372.332 339.012 371.122 338.362 369.803 338.188C368.758 338.008 367.247 337.804 366.498 338.723C366.45 338.781 366.532 338.868 366.586 338.805C367.363 337.833 369.196 338.154 370.265 338.411C371.485 338.703 372.748 339.349 373.39 340.477C374.809 342.951 373.536 346.246 371.13 347.563V347.563C368.831 348.715 366.036 348.051 364.501 345.988V345.988C363.081 343.859 363.441 341.01 365.346 339.301C365.405 339.247 365.317 339.16 365.259 339.213V339.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M384.621 346.951C381.87 347.247 379.455 350.085 379.431 352.86C379.431 354.318 380.403 355.441 381.491 356.287C382.58 357.132 383.921 358.134 385.326 358.075C386.823 358.012 388.135 356.87 389.214 355.947V355.947C390.432 355.035 391.256 353.693 391.517 352.195C391.833 350.032 390.327 345.638 387.396 346.751C387.323 346.751 387.352 346.897 387.425 346.868C389.068 346.246 390.458 347.806 391.027 349.181V349.181C391.504 350.346 391.584 351.636 391.255 352.851C390.9 354.182 390.001 355.145 388.961 356C387.804 356.943 386.356 358.172 384.757 357.905C383.542 357.701 382.22 356.753 381.282 355.961C380.184 355.057 379.421 353.93 379.581 352.452C379.854 349.886 381.982 347.335 384.602 347.053C384.679 347.053 384.679 346.921 384.602 346.931L384.621 346.951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M396.931 365.895C393.626 361.521 397.772 355.883 402.763 356.024C404.371 356.068 405.611 356.675 406.204 358.265V358.265C406.524 359.146 406.656 360.085 406.593 361.02V361.02C406.463 363.183 405.369 365.174 403.613 366.444C403.55 366.488 403.613 366.595 403.677 366.546V366.546C405.521 365.217 406.649 363.112 406.733 360.84C406.826 358.483 405.898 356.214 403.331 355.927C398.053 355.329 393.296 361.297 396.809 365.943C396.853 366.007 396.96 365.943 396.911 365.88L396.931 365.895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M407.099 365.443V365.443C407.132 365.433 407.152 365.398 407.142 365.365C407.136 365.344 407.12 365.327 407.099 365.321V365.321C407.065 365.331 407.046 365.366 407.055 365.399C407.061 365.42 407.078 365.437 407.099 365.443V365.443Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M360.024 364.738C360.418 362.925 360.996 361.054 362.405 359.766C364.291 358.046 366.614 358.493 368.767 359.397C372.169 360.855 373.715 364.155 373.141 367.761C373.141 367.839 373.243 367.873 373.258 367.795C373.87 364.009 372.218 360.665 368.641 359.207C366.697 358.41 364.597 357.973 362.775 359.314C361.045 360.593 360.345 362.687 359.917 364.704C359.917 364.782 360.019 364.811 360.034 364.738H360.024Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M357.697 413.946L369.589 415.53C369.667 415.53 369.667 415.418 369.589 415.408L357.697 413.824C357.619 413.824 357.619 413.936 357.697 413.946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M401.436 415.656V415.656C404.923 414.515 408.522 413.751 412.172 413.377C412.25 413.377 412.25 413.246 412.172 413.256V413.256C408.511 413.628 404.9 414.394 401.402 415.54C401.329 415.564 401.359 415.681 401.436 415.656V415.656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M355.694 429.668L362.6 429.478C363.149 429.478 364.214 429.658 364.705 429.352C365.035 429.143 364.918 429.065 365.137 428.773V428.773C365.613 427.986 366.482 427.521 367.402 427.563V427.563C367.435 427.554 367.455 427.519 367.445 427.485C367.439 427.464 367.423 427.448 367.402 427.442V427.442C366.802 427.402 366.207 427.574 365.72 427.928C365.516 428.083 365.404 428.258 365.234 428.414V428.414C364.604 429.041 363.742 429.379 362.853 429.347L355.709 429.541C355.631 429.541 355.631 429.668 355.709 429.663L355.694 429.668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M401.339 429.707L401.436 429.624V429.624C401.459 429.601 401.459 429.564 401.436 429.541C401.413 429.518 401.376 429.518 401.354 429.541L401.247 429.643C401.193 429.702 401.276 429.789 401.334 429.731L401.339 429.707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M401.397 429.624C403.827 429.682 406.291 429.658 408.736 429.532C409.183 429.532 410.058 429.624 410.442 429.405V429.405C410.545 429.188 410.663 428.978 410.797 428.778V428.778C410.99 428.478 411.215 428.2 411.467 427.947V427.947C411.897 427.525 412.389 427.171 412.925 426.898C412.993 426.859 412.925 426.752 412.862 426.791V426.791C412.104 427.181 411.44 427.734 410.918 428.409V428.409C410.796 428.622 410.661 428.828 410.515 429.026C410.029 429.512 409.144 429.396 408.508 429.425C406.139 429.538 403.772 429.564 401.407 429.502V429.502C401.374 429.512 401.354 429.547 401.364 429.581C401.37 429.602 401.386 429.618 401.407 429.624H401.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M396.091 273.01C394.72 273.944 393.884 274.391 393.884 274.391L393.272 278.911C393.068 280.266 393.952 280.369 393.952 280.369L397.179 281.341C397.179 281.341 397.709 279.197 398.107 277.035C398.506 274.872 402.064 269.642 402.064 269.642C402.064 269.642 397.733 271.898 396.091 273.01V273.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M369.715 291.926C369.715 291.926 387.882 299.498 400.289 300.484C400.289 300.484 398.651 296.295 398.471 295.935C398.292 295.576 397.354 293.048 395.555 293.019C393.757 292.99 388.45 290.589 388.45 290.589H388.45C384.837 289.183 381.092 288.139 377.272 287.474L374.604 286.93C374.604 286.93 369.948 285.233 370.23 286.93C370.512 288.626 369.715 291.926 369.715 291.926V291.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M359.257 377.262C359.257 377.262 371.98 379.6 375.368 379.007C375.368 379.007 375.922 370.502 375.936 370.342C375.951 370.181 377.064 368.024 375.232 368.16C373.327 368.301 362.071 366.886 362.071 366.886C362.071 366.886 359.641 366.114 359.845 367.78",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M395.119 379.104C395.119 379.104 407.395 379.483 410.457 377.063L409.213 370.915L408.45 367.78C408.45 367.78 408.523 366.536 406.705 366.808C404.887 367.081 396.679 368.048 396.679 368.048L394.38 368.208C394.38 368.208 392.99 367.494 393.505 369.593",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M363.635 273.822L367.1 271.538L368.252 263.174C368.252 263.174 365.166 272.49 363.635 273.822V273.822Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 122.5,
    y1: 154.5,
    x2: 288,
    y2: 123.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51D6E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 150.5,
    y1: 163,
    x2: 277,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51D6E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.de4861f0fa9a57090792c14275616f66.svg";
export { ForwardRef as ReactComponent };